import type { EventItem } from '@/entities/event/config';

interface EventSeatAvailability {
  noSeatsLeft: boolean;
  totalSeats: number | null;
  shouldShowLimitedSeatsSticker: boolean;
}

export function getEventSeatAvailability(
  event: Pick<EventItem, 'available_seats' | 'total_seats' | 'status'>,
): EventSeatAvailability {
  const totalSeats = typeof event.total_seats === 'number' ? event.total_seats : null;
  const noSeatsLeft = event.available_seats <= 0;
  const shouldShowLimitedSeatsSticker =
    event.status === 'available' &&
    !noSeatsLeft &&
    totalSeats !== null &&
    event.available_seats < totalSeats;

  return {
    noSeatsLeft,
    totalSeats,
    shouldShowLimitedSeatsSticker,
  };
}
